// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sTET","col":"styles_col__25ccR"};